import { microTask as t } from "./micro-task.js";
function o() {
  let n = [], r = { addEventListener(e, t2, s, a) {
    return e.addEventListener(t2, s, a), r.add(() => e.removeEventListener(t2, s, a));
  }, requestAnimationFrame(...e) {
    let t2 = requestAnimationFrame(...e);
    return r.add(() => cancelAnimationFrame(t2));
  }, nextFrame(...e) {
    return r.requestAnimationFrame(() => r.requestAnimationFrame(...e));
  }, setTimeout(...e) {
    let t2 = setTimeout(...e);
    return r.add(() => clearTimeout(t2));
  }, microTask(...e) {
    let t$1 = { current: true };
    return t(() => {
      t$1.current && e[0]();
    }), r.add(() => {
      t$1.current = false;
    });
  }, style(e, t2, s) {
    let a = e.style.getPropertyValue(t2);
    return Object.assign(e.style, { [t2]: s }), this.add(() => {
      Object.assign(e.style, { [t2]: a });
    });
  }, group(e) {
    let t2 = o();
    return e(t2), this.add(() => t2.dispose());
  }, add(e) {
    return n.includes(e) || n.push(e), () => {
      let t2 = n.indexOf(e);
      if (t2 >= 0) for (let s of n.splice(t2, 1)) s();
    };
  }, dispose() {
    for (let e of n.splice(0)) e();
  } };
  return r;
}
export {
  o as disposables
};
